<div class="form-container notesTableWithForm" [ngClass]="{ aumPreview: mode <= 1, aumPrint: mode <= 0 }">
    <form [formGroup]="form">
        <ng-container formArrayName="dataSource">
            <mat-table [dataSource]="dataSource.controls">
                <ng-container *ngFor="let property of OPTIONS.properties; trackBy: trackByIndex; let i = index">
                    <ng-container matColumnDef="{{ property.property }}">
                        <mat-header-cell
                            *matHeaderCellDef
                            [ngStyle]="{ flex: property.flex }"
                            [ngClass]="{
                                aumHighlight: property.highlighted && !editableHeaders,
                                hasInput: editableHeaders
                            }"
                        >
                            <div
                                style="margin-right: auto"
                                *ngIf="selectedFliName != null && property.property === 'accountName'"
                            >
                                <span *ngIf="tableNumber"> {{ tableNumber + ' ' + selectedFliName }}</span>
                                <span *ngIf="!tableNumber"> {{ selectedFliName }}</span>
                            </div>
                            <ng-container [ngSwitch]="property.headerType">
                                <div *ngSwitchCase="'date'">
                                    {{ property.name | dateLocale }}
                                </div>
                                <div *ngSwitchCase="'hidden'">&nbsp;</div>
                                <div
                                    *ngSwitchDefault
                                    [ngClass]="{
                                        'input-cell': editableHeaders,
                                        'table-title': property.property === 'text'
                                    }"
                                >
                                    <ham-referencing-input-component
                                        class="referencing-input"
                                        *ngIf="property.property != 'remove' && property.hasReference"
                                        [isEditMode]="mode === 2"
                                        [title]="textTitle"
                                        [isNumbered]="isNumbered"
                                        [isReferenced]="isReferenced"
                                        [numbering]="tableNumber"
                                        (titleChange)="onTitleChange($event, property.property)"
                                        (addNumbering)="onAddNumberingClick()"
                                        (addReferencing)="onAddReferencingClick()"
                                    ></ham-referencing-input-component>

                                    <aum-input
                                        *ngIf="
                                            mode === 2 &&
                                            property.property != 'text' &&
                                            property.property != 'remove' &&
                                            property.property !== 'accountName' &&
                                            !property.hasReference
                                        "
                                        [aumFormControl]="form?.get('headers')?.get(property.property)"
                                    ></aum-input>

                                    <div *ngIf="mode !== 2 && property.property === 'text' && !property.hasReference">
                                        {{ textTitle }}
                                    </div>
                                    <div *ngIf="mode !== 2 && property.property !== 'text'">{{ property.name }}</div>
                                </div>
                            </ng-container>
                        </mat-header-cell>
                        <mat-cell
                            class="hasInput"
                            *matCellDef="let element; let rowIndex = index"
                            [formGroup]="element"
                            [formGroupName]="rowIndex"
                            [ngStyle]="{ flex: property.flex }"
                            [ngClass]="{
                                aumHighlight: property.highlighted && mode <= 1,
                                todoHighlight:
                                    todoHighlight &&
                                    property.property != 'remove' &&
                                    (getFromControl(property.property, rowIndex)?.value === '' ||
                                        getFromControl(property.property, rowIndex)?.value === '-' ||
                                        getFromControl(property.property, rowIndex)?.value === 0 ||
                                        getFromControl(property.property, rowIndex)?.value == null),
                                aumText: property?.type === 'text',
                                'edit-cell': editableHeaders
                            }"
                        >
                            <ng-container [ngSwitch]="property?.type">
                                <!-- normal Label -->
                                <ng-container *ngSwitchCase="'label'">
                                    <!-- Skip -->
                                    <!-- Only Display Hidden -->
                                    <input
                                        matInput
                                        hidden
                                        formControlName="{{ property.property }}"
                                        [id]="property.property"
                                    />
                                </ng-container>

                                <!-- normal Text -->
                                <ng-container *ngSwitchCase="'text'">
                                    <ng-container [ngSwitch]="mode">
                                        <ng-container *ngSwitchCase="0">
                                            <div class="text">
                                                {{ getFromControl(property.property, rowIndex).value }}
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="1">
                                            <div class="text">
                                                {{ getFromControl(property.property, rowIndex).value }}
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="2">
                                            <ng-container [ngSwitch]="property.hasTotal">
                                                <aum-input
                                                    *ngSwitchCase="true"
                                                    [aumFormControl]="getFromControl(property.property, rowIndex)"
                                                    placeholder="{{
                                                        'aumico_notes_table_with_form_enter_placeholder' | i18next
                                                    }}"
                                                    floatLabel="auto"
                                                    [id]="property.property"
                                                    simpleInput="true"
                                                >
                                                </aum-input>
                                                <aum-input
                                                    *ngSwitchDefault
                                                    [aumFormControl]="getFromControl(property.property, rowIndex)"
                                                    [placeholder]="i != 0 ? property.name + '...' : ''"
                                                    [id]="property.property"
                                                    simpleInput="true"
                                                >
                                                </aum-input>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <!-- normal number -->
                                <ng-container *ngSwitchCase="'amount'">
                                    <ng-container [ngSwitch]="mode">
                                        <ng-container *ngSwitchCase="0">
                                            <div class="amount">
                                                {{
                                                    getFromControl(property.property, rowIndex).value != null &&
                                                    getFromControl(property.property, rowIndex).value !== ''
                                                        ? (getFromControl(property.property, rowIndex).value
                                                          | finNumber)
                                                        : ''
                                                }}
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="1">
                                            <div class="amount">
                                                {{
                                                    getFromControl(property.property, rowIndex).value != null &&
                                                    getFromControl(property.property, rowIndex).value !== ''
                                                        ? (getFromControl(property.property, rowIndex).value
                                                          | finNumber)
                                                        : ''
                                                }}
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="2">
                                            <aumico-number-input
                                                class="number-input"
                                                [control]="getFromControl(property.property, rowIndex)"
                                                placeholder="{{
                                                    'aumico_notes_table_with_form_enter_placeholder' | i18next
                                                }}"
                                                [disabled]="property.disabled"
                                            >
                                            </aumico-number-input>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <!-- Select -->
                                <ng-container *ngSwitchCase="'select'">
                                    <ng-container [ngSwitch]="mode">
                                        <ng-container *ngSwitchCase="0">
                                            <div>{{ getFromControl(property.property, rowIndex).value }} </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="1">
                                            <div>{{ getFromControl(property.property, rowIndex).value }} </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="2">
                                            <aum-select
                                                [aumFormControl]="getFromControl(property.property, rowIndex)"
                                                [placeholder]="property.name"
                                                [compareWith]="compareObjects"
                                                [id]="property.property"
                                                floatLabel="always"
                                                multiple="{{ property.multiple }}"
                                                [options]="property.options"
                                            >
                                                <aum-form-field-label>{{ property.name }}</aum-form-field-label>
                                            </aum-select>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>

                                <!-- Date -->
                                <ng-container *ngSwitchCase="'date'">
                                    <ng-container [ngSwitch]="mode">
                                        <ng-container *ngSwitchCase="0">
                                            <div>{{ getFromControl(property.property, rowIndex).value }} </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="1">
                                            <div>{{ getFromControl(property.property, rowIndex).value }} </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="2">
                                            <mat-form-field class="form-field" appearance="outline">
                                                <mat-label>{{ property.name }}</mat-label>
                                                <input
                                                    matInput
                                                    [matDatepicker]="dp"
                                                    formControlName="{{ property.property }}"
                                                />
                                                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                                                <mat-datepicker #dp></mat-datepicker>
                                            </mat-form-field>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>

                                <!-- TODO: File -->
                                <ng-container *ngSwitchCase="'file'">
                                    <ng-container [ngSwitch]="mode">
                                        <ng-container *ngSwitchCase="0"> </ng-container>
                                        <ng-container *ngSwitchCase="1"> </ng-container>
                                        <ng-container *ngSwitchCase="2">
                                            <button
                                                mat-icon-button
                                                (click)="onFileUploadClick(rowIndex)"
                                                disabled="{{ !editable }}"
                                            >
                                                <i class="fas fa-paperclip fa-lg"></i>
                                            </button>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>

                                <!-- remove-->
                                <ng-container *ngSwitchCase="'remove'">
                                    <ng-container [ngSwitch]="mode">
                                        <ng-container *ngSwitchCase="0"> </ng-container>
                                        <ng-container *ngSwitchCase="1"> </ng-container>
                                        <ng-container *ngSwitchCase="2">
                                            <button
                                                mat-icon-button
                                                (click)="removeAt(rowIndex)"
                                                disabled="{{ !editable }}"
                                                class="aum-remove-item"
                                                type="button"
                                            >
                                                <mat-icon svgIcon="aumico-pattern-icon-remove"></mat-icon>
                                            </button>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngSwitchDefault>
                                    {{ 'aumico_notes_table_with_form_no_formfield_defined' | i18next }}
                                    {{ property.type }}
                                </ng-container>
                            </ng-container>
                        </mat-cell>

                        <mat-footer-cell
                            *matFooterCellDef
                            class="hasInput"
                            [ngClass]="{
                                aumHighlight: property.highlighted && mode <= 1,
                                aumText: property?.type === 'text',
                                hidden: !hasTotalRow
                            }"
                            [ngStyle]="{ flex: property.flex }"
                        >
                            <ng-container [formGroup]="form" *ngIf="hasTotalRow">
                                <ng-container formGroupName="totalRow">
                                    <ng-container [ngSwitch]="mode">
                                        <ng-container *ngSwitchCase="0">
                                            <div>{{ getFooterCellContent(property) }} </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="1">
                                            <div>{{ getFooterCellContent(property) }} </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="2">
                                            <aum-input
                                                *ngIf="property?.type === 'text' && hasFooter(property)"
                                                [aumFormControl]="getFromControlOfTotalRow(property.property)"
                                                placeholder="{{
                                                    'aumico_notes_table_with_form_enter_placeholder' | i18next
                                                }}"
                                                floatLabel="auto"
                                                [id]="property.property"
                                                simpleInput="true"
                                                [ngClass]="{
                                                    hasFooterCellContent: getFooterCellContent(property)
                                                }"
                                            >
                                                <aum-form-field-label>{{
                                                    'aumico_notes_table_with_form_total' | i18next
                                                }}</aum-form-field-label>
                                            </aum-input>

                                            <aumico-number-input
                                                class="number-input"
                                                *ngIf="property?.type === 'amount' && hasFooter(property)"
                                                [control]="getFromControlOfTotalRow(property.property)"
                                                placeholder="{{
                                                    'aumico_notes_table_with_form_enter_placeholder' | i18next
                                                }}"
                                                [ngClass]="{
                                                    hasFooterCellContent: getFooterCellContent(property)
                                                }"
                                            >
                                            </aumico-number-input>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </mat-footer-cell>
                    </ng-container>
                </ng-container>
                <div *ngIf="firstHeaders.length">
                    <ng-container *ngFor="let header of firstHeaders">
                        <ng-container matColumnDef="f-{{ header.key }}">
                            <mat-header-cell
                                *matHeaderCellDef
                                [ngClass]="{
                                    aumHighlight: header.highlighted
                                }"
                                [ngStyle]="{ flex: header.flex }"
                            >
                                <ng-container [ngSwitch]="header.type">
                                    <div *ngSwitchCase="'date'">
                                        {{ header.name | dateLocale }}
                                    </div>
                                    <div *ngSwitchCase="'hidden'">&nbsp;</div>

                                    <div *ngSwitchCase="'translatable'">
                                        {{ header.name | i18next }}
                                    </div>
                                    <div *ngSwitchDefault>{{ header.name }}</div>
                                </ng-container>
                            </mat-header-cell>
                        </ng-container>
                    </ng-container>
                </div>

                <div *ngIf="additionalHeaders?.length > 0">
                    <ng-container *ngFor="let additionalHeader of additionalHeaders">
                        <ng-container matColumnDef="{{ additionalHeader.key }}">
                            <mat-header-cell
                                *matHeaderCellDef
                                [ngClass]="{
                                    aumHighlight: additionalHeader.highlighted,
                                    aumText: additionalHeader?.type === 'text'
                                }"
                                [ngStyle]="{ flex: additionalHeader.flex }"
                            >
                                <ng-container [ngSwitch]="additionalHeader.type">
                                    <div *ngSwitchCase="'date'">
                                        {{ additionalHeader.name | dateLocale }}
                                    </div>
                                    <div *ngSwitchCase="'hidden'">&nbsp;</div>
                                    <div *ngSwitchCase="'translatable'">
                                        {{ additionalHeader.name | i18next }}
                                    </div>

                                    <div *ngSwitchDefault>{{ additionalHeader.name }}</div>
                                </ng-container>
                            </mat-header-cell>
                        </ng-container>
                    </ng-container>
                </div>

                <div *ngIf="OPTIONS.properties.length === 0">
                    <div>
                        {{ 'aumico_notes_table_with_form_no_properties_defined' | i18next }}
                    </div>
                </div>

                <mat-header-row
                    [hidden]="getFirstHeadersKeys().length === 0"
                    *matHeaderRowDef="getFirstHeadersKeys()"
                ></mat-header-row>
                <mat-header-row
                    [hidden]="additionalHeaderKeys.length === 0"
                    *matHeaderRowDef="additionalHeaderKeys"
                ></mat-header-row>
                <mat-header-row
                    *matHeaderRowDef="DISPLAYEDCOLUMNS"
                    [ngClass]="{ 'edit-mode': editableHeaders }"
                ></mat-header-row>
                <mat-row *matRowDef="let row; columns: DISPLAYEDCOLUMNS"></mat-row>

                <mat-footer-row
                    class="sticky-footer"
                    *matFooterRowDef="DISPLAYEDCOLUMNS"
                    [ngClass]="{ hidden: !hasTotalRow }"
                ></mat-footer-row>
            </mat-table>
        </ng-container>
    </form>

    <!-- Footnotes Section -->
    <div class="footnote" *ngIf="hasFootnotes && mode === 2" [formGroup]="form">
        <input hamInput [formControl]="form.get('footnote')" [placeholder]="'Add Footnote to this table'" />
    </div>

    <div *ngIf="editable && enableAddNewItem && mode === 2">
        <button aum-icon-button color="basic" icon="plus" (click)="addRow()">
            {{ getAddNewItemText() | i18next }}
        </button>
    </div>
</div>
